<script>
  import { default as colorData } from "./colors.json";
  import { orderByDistance, compare } from "./colors-distance.js";

  let filesList = Object.entries(colorData);
  let order = {
    gray: 1,
    zinc: 2,
    slate: 2.5,
    neutral: 3,
    stone: 4,
    sky: 5,
    blue: 6,
    indigo: 7,
    violet: 8,
    fuchsia: 9,
    pink: 10,
    rose: 11,
    red: 12,
    orange: 13,
    purple: 13.5,
    amber: 14,
    yellow: 15,
    lime: 16,
    green: 17,
    emerald: 18,
    teal: 19,
    cyan: 20,
  };
  // Holds table sort state.  Initialized to reflect table sorted by id column ascending.
  $: sortBy = [{ col: "twColor", ascending: true }];
  $: showOpacity = true;
  // Holds table sort state.  Initialized to reflect table sorted by id column ascending.
  let array = filesList
    .map((el) => {
      let c = el[0].split(";")[0];
      let files = el[1];
      return {
        key: el[0],
        color: c,
        files: files,
        size: files.length,
        closestColors: orderByDistance(c).slice(0, 3),
        twColor: orderByDistance(c)[0]?.name,
        hasOpacity: files[0].opacity < 1,
      };
    })
    .sort((a, b) => {
      let [color, v] = a.twColor.split("-");
      let [color2, v2] = b.twColor.split("-");
      return (
        order[color] - order[color2] ||
        v - v2 ||
        a.twColor.localeCompare(b.twColor)
      );
    });
  let sortedArray = array;
  $: sort = (column, e) => {
    // Check if column is already in sortBy array
    let existingSort = sortBy.find((s) => s.col === column);

    if (existingSort && (e.shiftKey || sortBy.length === 1)) {
      // If column is found, toggle its ascending value
      existingSort.ascending = !existingSort.ascending;
      sortBy = [...sortBy];
    } else if (e.shiftKey) {
      // If column is not found, add new sort criteria to sortBy array
      sortBy = [...sortBy, { col: column, ascending: true }];
    } else {
      // If column is not found, replace sortBy array with new sort criteria
      sortBy = [{ col: column, ascending: true }];
    }

    // Custom sort function considering all sortBy criteria
    let sort = (a, b) => {
      for (let sortCrit of sortBy) {
        let sortModifier = sortCrit.ascending ? 1 : -1;
        if (sortCrit.col === "twColor") {
          let [color, v] = a.twColor.split("-");
          let [color2, v2] = b.twColor.split("-");
          return (
            (order[color] - order[color2] ||
              v - v2 ||
              a.twColor.localeCompare(b.twColor)) * sortModifier
          );
        }
        if (a[sortCrit.col] < b[sortCrit.col]) return -1 * sortModifier;
        if (a[sortCrit.col] > b[sortCrit.col]) return 1 * sortModifier;
      }
      return 0; // Return 0 if all criteria are equal
    };
    sortedArray = array.sort(sort);
  };

  $: filteredArray = sortedArray.filter((el) => {
    return showOpacity ? true : !el.hasOpacity;
  });
</script>

{filteredArray.length} colors sorted by: {JSON.stringify(sortBy)}
<label>
  <input type="checkbox" bind:checked={showOpacity} /> show colors with opacity
</label>
<table>
  <thead>
    <tr>
      <th>IDX</th>
      <th on:click={(e) => sort("color", e)}>Color</th>
      <th>Color sample</th>
      <th on:click={(e) => sort("twColor", e)}>Tailwind color candidates</th>
      <th on:click={(e) => sort("size", e)}>Files</th>
      <th on:click={(e) => sort("hasOpacity", e)}>hasOpacity</th>
    </tr>
  </thead>
  <tbody>
    {#each filteredArray as c, idx (c.key)}
      <tr>
        <td>{idx + 1}</td>
        <td>{c.key}</td>
        <td style="background-color:{c.color.split(';')[0]}"></td>
        <td style="display: flex; flex-direction: row;padding: 0;">
          {#each c.closestColors as twc}
            <div
              style="width: 70px; height: 30px;flex-grow:1; background-color: {twc.hex}"
            >
              {twc.name}
            </div>
          {/each}
        </td>
        <td style="max-width: 600px">
          <div style="display: flex">
            <div>{c.files[0].file}: {c.files[0].original}</div>
            <button popovertarget={c.key}>
              show all {c.size} files
            </button>
            <div popover id={c.key}>
              <ul>
                {#each c.files as file}
                  <li>
                    <a
                      href="https://github.com/search?q=repo%3ACyberhavenInc%2Fdataflow%20{encodeURIComponent(
                        file.original
                      )}%20path{encodeURIComponent(':' + file.file)}&type=code"
                      target="_blank">{file.file}</a
                    >: {file.original}
                  </li>
                {/each}
              </ul>
            </div>
          </div>
        </td>
        <td>{c.hasOpacity}</td>
      </tr>
    {/each}
  </tbody>
</table>

<style>
  table {
    width: 100%;
    border-collapse: collapse;
  }
  th,
  td {
    border: 1px solid #ddd;
    padding: 4px;
    text-align: left;
    height: 20px;
  }
  th {
    background-color: #f4f4f4;
  }
</style>
